/**
 * 解析环境变量
 *
 * @param mode - 环境变量所属环境别名，对应`.env(.local)?.<xxx>`
 *
 * @returns 环境变量
 */
export const resolveEnvironmentVariables = (mode?: keyof OmeImportMetaEnv) => {
  //环境
  const ENV_NAME = import.meta.env?.MODE || 'production';
  // 请求的变量名
  const environment = mode?.toString().includes('VITE_') ? mode : `VITE_${mode}`;
  // 请求的变量值
  const variable = import.meta.env[environment];

  const variables = {
    /**
     * 环境变量所属环境别名，对应`.env(.local)?.<xxx>`
     */
    ENV_NAME,

    /**
     * 是否为dev环境
     */
    IS_DEV: ENV_NAME === 'development' || ENV_NAME === 'native',

    /**
     * 是否为测试环境
     */
    IS_TEST: ENV_NAME === 'testing',

    /**
     * 是否为预发布环境
     */
    IS_PRERELEASE: ENV_NAME === 'prerelease',

    /**
     * 是否为灾备环境
     */
    IS_RESERVE: ENV_NAME === 'reserve',

    /**
     * 是否为紫荆正式环境
     */
    IS_ZJ_PROD: ENV_NAME === 'zjproduction',

    /**
     * 是否为集约化正式环境
     */
    IS_JYH_PROD: ENV_NAME === 'jiyuehua' || ENV_NAME === 'jiyuehuadomain',
    /**
     * 是否为集约化灾备
     */
    IS_JYH_RESERVE: ENV_NAME === 'jiyuehuareserve',
    /**
     * 是否为集约化正式环境
     */
    IS_JYH_PROD_DOMAIN:
      ENV_NAME === 'jiyuehuadomain' || window.location.host.includes('dwjyh.cqliving.com:8000'),

    /**
     * 是否为正式环境
     */
    IS_PROD: ENV_NAME === 'production',
  };

  /**
   * 登录、密码重置等授权接口是否可绕过验证码校验功能
   */
  const IS_CAPTCHA_SKIPPED =
    variables.IS_DEV ||
    variables.IS_TEST ||
    variables.IS_ZJ_PROD ||
    variables.IS_JYH_PROD ||
    variables.IS_JYH_RESERVE;
  const IS_LIAR_HOME_VISIBLE = import.meta.env.VITE_LIAR_HOME_VISIBLE === 'true';

  return {
    ...variables,
    IS_CAPTCHA_SKIPPED,
    IS_LIAR_HOME_VISIBLE,
    variable,
  };
};

/**
 * @param config - 需要获取的配置
 *
 * @returns 当前域名对应的配置
 *
 * 获取当前域名对应的配置
 */
export const getBaseConfigByOrigin = (config: string) => {
  // 匹配完整的HTTP/HTTPS URL或协议相对URL（以//开头）
  const isUrl = config.match(/^(https?:)?\/\//);

  if (isUrl) {
    // 如果是完整URL，直接返回
    return config;
  }

  // 如果不是URL，判断是否是json字符串，如果是，则返回当前域名的对应值
  const isJson = config.startsWith('{') && config.endsWith('}');
  if (isJson) {
    try {
      const json = JSON.parse(config);
      const host = window.location.host;
      return json[`//${host}`] || `//${window.location.host}`;
    } catch (error) {
      console.error(error);
      return `//${window.location.host}`;
    }
  }

  return `//${window.location.host}`;
};
